import ResumeExaminationModal from './ResumeExaminationModal';

export default ResumeExaminationModal;
